import ClassicSelect from '@components/@material-extend/ClassicSelect'
import ClassicTextField from '@components/@material-extend/ClassicTextField'
import { FontStatusOptions } from '@constants/common.constants'
import { Box, Button, Grid, ListItemText, MenuItem } from '@mui/material'
import { FontsParams } from '@services/fonts.services'
import _ from 'lodash'
import React from 'react'
import { FieldValues } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import useFormFilter from './useFormFilter'

export type FilterParams = Omit<FontsParams, 'per_page' | 'page'>

interface FilterFormProps {
  onFilter: (data: FilterParams) => void
}

const FilterForm: React.FC<FilterFormProps> = (props) => {
  const { onFilter } = props
  const { t } = useTranslation()

  const { Controller, methods } = useFormFilter()
  const { control, handleSubmit } = methods

  const onSubmit = (values: any) => {
    onFilter({
      name: values.name,
      status: !_.isEmpty(values.status) ? values.status : null,
    })
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)} method="post">
      <Grid container spacing={{ xs: 0.5, sm: 1, md: 1 }} pb={2}>
        <Grid item xs={4}></Grid>
        <Grid item xs={3}>
          <Controller
            name="name"
            control={control}
            render={({ field: { ref, ...rest } }: FieldValues) => (
              <ClassicTextField
                {...rest}
                inputRef={ref}
                fullWidth
                label={t('fonts.name')}
                placeholder={t('fonts.name')}
              />
            )}
          />
        </Grid>
        <Grid item xs={3}>
          <Box
            sx={{
              width: '100%',
            }}
          >
            <Controller
              control={control}
              name="status"
              render={({ field: { onChange, value } }) => (
                <ClassicSelect
                  label={t('SYSCOMMON.status')}
                  value={value}
                  onChange={onChange}
                >
                  {FontStatusOptions.map((item, k) => (
                    <MenuItem key={k} value={item.value}>
                      <ListItemText primary={item.name} />
                    </MenuItem>
                  ))}
                </ClassicSelect>
              )}
            />
          </Box>
        </Grid>
        <Grid item xs={2}>
          <Box
            sx={{
              width: '100%',
              height: '100%',
              display: 'flex',
              alignItems: 'flex-end',
              justifyContent: 'center',
            }}
          >
            <Button
              variant="contained"
              fullWidth
              color="secondary"
              type="submit"
            >
              {t('SYSCOMMON.search')}
            </Button>
          </Box>
        </Grid>
      </Grid>
    </form>
  )
}

export default FilterForm
